import { render } from "./SuspenseWithError.vue?vue&type=template&id=f3e5502e&ts=true"
import script from "./SuspenseWithError.vue?vue&type=script&lang=ts"
export * from "./SuspenseWithError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.2.37_webpack@5.105.4_@swc+core@1.15.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__